import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';

const handleApiError = (error, defaultMessage) => {
    console.error('API Error:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
    });

    return {
        isSuccess: false,
        statusCode: error.response?.status || 500,
        resultMessage: error.response?.data?.message || defaultMessage,
        data: null
    };
};

export const getActiveEvents = async (pageNum = 1, pageSize = 6, searchTerm = "", sortBy = "", startDate = null, endDate = null) => {
    try {
        console.log('Fetching active events with params:', { pageNum, pageSize, searchTerm, sortBy, startDate, endDate });
        
        const response = await axios.post(`${baseUrl}/Event/GetActiveEvents`, {
            pageNum: pageNum.toString(),
            pageSize: pageSize.toString(),
            searchTerm,
            sortBy,
            startDate,
            endDate
        });

        console.log('Active events response:', response.data);

        if (!response.data) {
            return {
                isSuccess: false,
                statusCode: 500,
                resultMessage: 'Sunucudan geçersiz yanıt alındı',
                data: null
            };
        }

        return response.data;
    } catch (error) {
        return handleApiError(error, 'Etkinlikler yüklenirken bir hata oluştu');
    }
};

export const getEventByGuid = async (guidOrUrlTag) => {
    if (!guidOrUrlTag) {
        console.error('getEventByGuid called without GUID or URL Tag');
        return {
            isSuccess: false,
            statusCode: 400,
            resultMessage: 'GUID veya URL etiketi gerekli',
            data: null
        };
    }

    try {
        console.log('Fetching event details for identifier:', guidOrUrlTag);
        
        const response = await axios.post(`${baseUrl}/Event/GetEventByGuid`, {
            guid: guidOrUrlTag
        });
        console.log('Event details response:', response.data);

        if (!response.data) {
            return {
                isSuccess: false,
                statusCode: 500,
                resultMessage: 'Sunucudan geçersiz yanıt alındı',
                data: null
            };
        }
        
        if (response.data?.isSuccess && response.data?.data) {
            return response.data;
        }
        
        console.warn('Event not found or invalid response:', response.data);
        return {
            isSuccess: false,
            statusCode: 404,
            resultMessage: 'Etkinlik bulunamadı',
            data: null
        };
    } catch (error) {
        return handleApiError(error, 'Etkinlik detayları yüklenirken bir hata oluştu');
    }
};
